import $ from 'jquery';
export default {
    name: 'Loading',
    show({element = 'body', message = "Đang tải...!"}) {
        if (element) {
            $(element).addClass('loading').attr('data-content', message);
        }
    },
    hide({element = '.loading'}) {
        if (element) {
            $(element).removeClass('loading').attr('data-content', '');
        }
    }
}



